<template>
  <cTable
    ref="table"
    :fields="fields"
    :modals="modals"
    :header="header"
    :methods="methods"
  >
  </cTable>
</template>

<script>
import {
  getBag,
  getDetails,
  postStatist,
  postMoveCnb,
  exportPackage,
  boardBag,
  getChannel,
  packagePrint,
  getSite,
  packageCheck,
  getClientType
} from "@/api/bag/list";
import { getWarehouse } from "@/api/storage/warehouse";
// import { add, getStatus, getDetails, update, del } from "@/api/tracker/status";
import cTable from "@/base/common/index";
import { getSelectType } from "@/api/public";
import getLodop, { printType } from "@/utils/lodop";

export default {
  name: "bag",
  components: {
    cTable
  },
  async mounted() {
    let selectData = (await getSelectType("SHIPPING_WAREHOUSE")).data.payload;
    this.header.searchs.forEach(item => {
      if (item.key === "warehouse_id")
        item.options = selectData["SHIPPING_WAREHOUSE"];
    });
  },
  methods: {},
  data() {
    let boardList = [
        { label: this.$t("YES"), value: "YES" },
        { label: this.$t("NO"), value: "NO" }
      ],
      typeList = [
        { label: "MoveOrder", value: "IN" },
        { label: "RemoveOrder", value: "OUT" }
      ],
      statusList = [
        { label: "n_process", value: 2 },
        { label: "y_process", value: 1 }
      ],
      statusList_t = {
        1: "y_process",
        2: "n_process"
      },
      keywordsList = [
        { label: "bagNum", value: 1 },
        { label: "orderNum", value: 2 },
        { label: "packing_number", value: 3 }
      ];
    return {
      methods: {
        list: getBag,
        exportPackage,
        getDetails,
        postMoveCnb,
        postStatist,
        boardBag,
        getChannel,
        packagePrint,
        getSite,
        packageCheck,
        getClientType
      },
      modals: {
        Detection: {
          type: "add",
          footer: {
            show: false
          },
          config: {
            title: this.$tz("装袋,检测"),
            modalBind: {
              width: 500
            },
            formBind: {
              labelWidth: 100
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              airway_number: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur"
                }
              ]
            }
          },
          grid: [{ airway_number: 24 }],
          fields: [
            {
              key: "airway_number",
              name: () => this.$tz("订单号"),
              placeholder() {
                return this.$tz("订单号");
              },
              component: "Input",
              methods: {
                "on-enter"({ formData }) {
                  this.$page
                    .handleRequestMethods("packageCheck", formData, true, true)
                    .then(res => {
                      this.$modal.list.unshift(Object.assign(res, formData));
                      formData.airway_number = "";
                    });
                }
              }
            }
          ],
          table: {
            config: {
              height: 500
            },
            fields: [
              {
                name: () => this.$tz("订单号"),
                key: "airway_number",
                minWidth: 110
              },
              {
                name: () => this.$tz("信息"),
                key: "msg",
                minWidth: 110
              }
            ]
          }
        },
        printLabel: {
          methods: {
            ok({ row, close }) {
              this.$page.openLoading();
              // if(row.clientType !== 'other'){
              // 	row['is_tt'] = 'NO'
              // 	row['is_temu'] = 'NO'
              // 	row['is_'+row.clientType] = 'YES'
              // }else{
              // 	row['is_tt'] = 'NO'
              // 	row['is_temu'] = 'NO'
              // }
              this.$page
                .handleRequestMethods("packagePrint", row, false, false)
                .then(res => {
                  setTimeout(() => {
                    this.$page.closeLoading();
                  }, 1000);
                  let LODOP = getLodop(this);
                  this.$Message.success({
                    content: this.$t("startPrint"),
                    background: true
                  });
                  let sizes = {
                    0: { width: "90mm", height: "60mm" },
                    1: { width: "100mm", height: "150mm" }
                  };
                  let size = sizes[row.size];
                  LODOP.PRINT_INIT("打印任务名"); //首先一个初始化语句
                  LODOP.SET_PRINT_PAGESIZE(1, size.width, size.height, ""); //规定纸张大小；使用A4纸
                  LODOP.SET_PRINTER_INDEX(row.printType);
                  res.payload.forEach(t => {
                    LODOP.SET_PRINT_STYLE("FontSize", 25);
                    LODOP.SET_PRINT_STYLE("FontName", "fangsong");
                    LODOP.SET_PRINT_STYLE("Alignment", 2);
                    LODOP.SET_PRINT_STYLE("Bold", 1);
                    LODOP.SET_PRINT_STYLE("ShowBarText", 0);
                    LODOP.ADD_PRINT_TEXT(
                      "20mm",
                      "5mm",
                      "80mm",
                      "10mm",
                      t.package_number
                    );
                    LODOP.ADD_PRINT_BARCODE(
                      "5mm",
                      "5mm",
                      "80mm",
                      "15mm",
                      "128Auto",
                      t.package_number
                    );
                    LODOP.SET_PRINT_STYLE("Bold", 0);
                    LODOP.SET_PRINT_STYLE("Alignment", 1);
                    LODOP.SET_PRINT_STYLE("FontSize", 13.5);
                    LODOP.ADD_PRINT_TEXT(
                      "30mm",
                      "5mm",
                      "34mm",
                      "15mm",
                      "COUNTRY:" + row.to_country
                    );
                    LODOP.ADD_PRINT_TEXT(
                      "30mm",
                      "40mm",
                      "50mm",
                      "15mm",
                      "ACCOUNT:" + t.create_name
                    );
                    LODOP.ADD_PRINT_TEXT(
                      "45mm",
                      "5mm",
                      "34mm",
                      "15mm",
                      "DATE:"
                    );
                    LODOP.ADD_PRINT_TEXT(
                      "45mm",
                      "47.5mm",
                      "35mm",
                      "15mm",
                      "PICS:"
                    );
                    LODOP.NEWPAGE();
                  });
                  LODOP.PREVIEW(); //打印预览
                  // LODOP.PRINT(); //打印预览
                })
                .catch(error => {
                  this.$page.closeLoading();
                });
              // });
            }
          },
          config: {
            title: this.$t("printLabel"),
            modalBind: {
              width: 1000
            },
            formBind: {
              labelWidth: 80
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              from_country: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "change"
                }
              ],
              to_country: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "change"
                }
              ],
              channel_id: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "change",
                  type: "number"
                }
              ],
              type: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "change",
                  type: "number"
                }
              ],
              client_type: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "change",
                  type: "number"
                }
              ],
              num: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                  type: "number"
                }
              ],
              site: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "change"
                }
              ]
            }
          },
          grid: [
            { printType: 24 },
            { size: 24 },
            // { from_country: 24 },
            { is_box: 24 },
            // { channel_id: 24 },
            // { is_mix: 24 },
            { to_country: 24 },
            { type: 24 },
            //{ is_tt: 24 },
            // { is_temu: 24 },
            { client_type: 24 },
            { site: 24 },
            { is_charge: 24 },
            { num: 24 }
          ],
          fields: [
            {
              name: this.$tz("尺寸"),
              key: "size",
              component: "Radio",
              options: [
                { label: "90*60", value: 0 },
                { label: "100*150", value: 1 }
              ],
              optionsFn: "",
              optionsKey: "",
              default: 0,
              bind: {
                border: true
              }
            },
            {
              name: this.$tz("客户,类型"),
              component: "Radio",
              key: "client_type",
              bind: {
                border: true
              },
              options: [],
              optionsFn: "",
              optionsKey: "",
              default: 1,
              methods: {
                list({ field }) {
                  this.$page.handleRequestMethods("getClientType").then(res => {
                    field.options = res.payload.map(t => {
                      return {
                        ...t,
                        disabled({ formData }) {
                          if (t.value === 1) {
                            let disabled = !(formData.to_country === "SA");
                            if (disabled && formData.client_type == 1)
                              formData.client_type = 9;
                            return disabled;
                          } else return false;
                        }
                      };
                    });
                  });
                }
              }
            },
            {
              key: "printType",
              name: this.$tz("打印机"),
              component: "Select",
              options: [],
              default: -1,
              placeholder: () => this.$tz("请选择,打印机"),
              methods: {
                list({ field }) {
                  field.options = printType.call(this);
                }
              }
            },
            {
              name: this.$tz("起运国"),
              key: "from_country",
              component: "Select",
              placeholder: () => this.$tz("起运国"),
              options: [],
              optionsFn: "formCountry",
              optionsKey: "",
              default: "CN",
              methods: {
                // "on-change"({ formData, fields }) {
                //   fields.forEach((t) => {
                //     if (t.key === "channel_id") {
                //       t.options = [];
                //     }
                //   });
                //   formData.channel_id = "";
                //   formData.to_country &&
                //     formData.from_country &&
                //     this.$page
                //       .handleRequestMethods("getChannel", {
                //         from_country: formData.from_country,
                //         to_country: formData.to_country,
                //       })
                //       .then((res) => {
                //         fields.forEach((t) => {
                //           if (t.key === "channel_id") {
                //             t.options = res.payload;
                //           }
                //         });
                //       });
                // },
              }
            },
            {
              name: this.$tz("目的国"),
              key: "to_country",
              component: "Select",
              placeholder: () => this.$tz("目的国"),
              options: [],
              optionsFn: "toCountry",
              optionsKey: "",
              default: "SA",
              methods: {
                "on-change"({ formData, fields }) {
                  fields.forEach(t => {
                    if (t.key === "channel_id" || t.key === "site") {
                      t.options = [];
                    }
                  });
                  formData.site = "RUH";
                  // formData.channel_id = "";
                  // formData.to_country === 'SA' &&
                  //   formData.from_country &&
                  //   this.$page
                  //     .handleRequestMethods("getChannel", {
                  //       from_country: formData.from_country,
                  //       to_country: formData.to_country,
                  //     })
                  //     .then((res) => {
                  //       fields.forEach((t) => {
                  //         if (t.key === "channel_id") {
                  //           t.options = res.payload;
                  //         }
                  //       });
                  //     });
                  formData.to_country === "SA" &&
                    this.$page
                      .handleRequestMethods("getSite", {
                        from_country: formData.from_country,
                        to_country: formData.to_country
                      })
                      .then(res => {
                        fields.forEach(t => {
                          if (t.key === "site") {
                            t.options = res.payload;
                          }
                        });
                      });
                }
              }
            },
            {
              name: this.$tz("站点"),
              key: "site",
              component: "Select",
              placeholder: () => this.$tz("站点"),
              options: [],
              optionsFn: "",
              optionsKey: "",
              default: "RUH",
              show: ({ formData }) =>
                formData.is_box === "NO" &&
                formData.to_country === "SA" &&
                formData.type === 9,
              methods: {
                list({ formData, fields }) {
                  formData.to_country === "SA" &&
                    this.$page
                      .handleRequestMethods("getSite", {
                        to_country: formData.to_country
                      })
                      .then(res => {
                        fields.forEach(t => {
                          if (t.key === "site") {
                            t.options = res.payload;
                          }
                        });
                      });
                }
              }
            },
            {
              name: this.$tz("客户,类型"),
              key: "clientType",
              component: "Radio",
              options: [
                {
                  label: "TT",
                  value: "tt",
                  disabled({ formData }) {
                    let disabled = !(
                      formData.to_country === "SA" && formData.type === 9
                    );
                    if (disabled && formData.clientType === "tt")
                      formData.clientType = "other";
                    return disabled;
                  }
                },
                { label: "TEMU", value: "temu" },
                { label: this.$tz("其他"), value: "other" }
              ],
              optionsFn: "",
              optionsKey: "",
              default: "tt",
              bind: {
                border: true
              }
            },
            {
              name: this.$tz("是否,TT"),
              key: "is_tt",
              component: "Radio",
              options: [],
              optionsFn: "YesNo",
              optionsKey: "",
              default: "NO",
              bind: {
                border: true
              },
              show: ({ formData }) =>
                formData.to_country === "SA" && formData.type === 9
            },
            {
              name: this.$tz("是否,TEMU"),
              key: "is_temu",
              component: "Radio",
              options: [],
              optionsFn: "YesNo",
              optionsKey: "",
              default: "NO",
              bind: {
                border: true
              }
            },
            {
              name: this.$tz("是否,纸箱"),
              key: "is_box",
              component: "Radio",
              options: [],
              optionsFn: "YesNo",
              optionsKey: "",
              default: "NO",
              bind: {
                border: true
              }
            },
            {
              name: this.$tz("是否,带电"),
              key: "is_charge",
              component: "Radio",
              options: [],
              optionsFn: "YesNo",
              optionsKey: "",
              default: "YES",
              bind: {
                border: true
              }
            },
            // {
            //   name: this.$tz("是否,混装"),
            //   key: "is_mix",
            //   component: "Radio",
            //   options: [],
            //   optionsFn: "YesNo",
            //   optionsKey: "",
            //   default: "NO",
            //   bind: {
            //     border: true,
            //   },
            //   show: ({ formData }) => formData.to_country === "SA",
            // },
            {
              name: this.$tz("混装,类型"),
              key: "type",
              component: "Radio",
              placeholder: () => this.$tz("混装,类型"),
              options: [],
              optionsFn: "getMixType",
              bind: {
                border: true
              },
              optionsKey: "",
              default: 9,
              show: ({ formData }) => formData.to_country === "SA"
            },
            // {
            //   name: this.$tz("装袋,渠道"),
            //   key: "channel_id",
            //   component: "Select",
            //   placeholder: () => this.$tz("装袋,渠道"),
            //   options: [],
            //   optionsFn: "",
            //   optionsKey: "",
            //   default: "",
            // },
            // {
            //   name: this.$tz("装袋,类型"),
            //   key: "type",
            //   component: "Select",
            //   placeholder: () => this.$tz("装袋,类型"),
            //   options: [],
            //   optionsFn: "getPackageType",
            //   optionsKey: "",
            //   default: "",
            // },
            {
              name: this.$tz("打印,数量"),
              placeholder: () => this.$tz("打印,数量"),
              key: "num",
              component: "InputNumber",
              default: 1,
              bind: {
                border: true,
                min: 1,
                step: 1,
                style: "width:100%"
              }
            }
          ]
        },
        move: {
          type: "add",
          methods: {
            ok({ row, close }) {
              let data = this.handleFilterData();
              this.$page
                .handleRequestMethods("boardBag", data, true, true)
                .then(res => {
                  this.$page.getList();
                  close();
                });
            }
          },
          config: {
            title: this.$tz("板货,操作"),
            modalBind: {
              width: 500
            },
            formBind: {
              labelWidth: 100
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              type: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur"
                }
              ],
              board_number: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur"
                }
              ],
              airway_number: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur"
                }
              ]
            }
          },
          grid: [{ type: 24 }, { board_number: 24 }, { airway_number: 24 }],
          fields: [
            {
              name: this.$tz("类型"),
              key: "type",
              component: "Radio",
              options: [
                { label: this.$tz("移入"), value: "IN" },
                { label: this.$tz("移出"), value: "OUT" }
              ],
              default: "IN",
              optionsFn: "",
              optionsKey: "",
              bind: {
                border: true
              }
            },
            {
              name: () => this.$tz("板号"),
              key: "board_number",
              component: "Input",
              placeholder: () => this.$tz("板号")
            },
            {
              key: "airway_number",
              name: () => this.$tz("订单号"),
              placeholder() {
                return this.$tz("订单号");
              },
              component: "Input",
              bind: {
                type: "textarea",
                autosize: { minRows: 4 }
              }
            }
          ]
        },
        operation: {
          methods: {
            ok({ row, close }) {
              let data = {
                airwayBillNumber: row.airwayBillNumber.split(/\s+/),
                packageId: row.packageId,
                type: row.type
              };
              this.$page
                .handleRequestMethods("postMoveCnb", data, false, true)
                .then(e => {
                  console.log(e);
                  this.$Message[e.payload == 1 ? "error" : "success"]({
                    content:
                      e.msg ||
                      e.message ||
                      this.$t("operation") + this.$t("success"),
                    duration: e.payload == 1 ? 0 : 3,
                    closable: true
                  });
                  this.$page.getList();
                  close();
                });
            }
          },
          footer: {
            ok: {},
            cancel: {}
          },
          config: {
            modalBind: {
              width: 500
            },
            formBind: {
              labelWidth: 120
            },
            rowBind: {
              gutter: 13,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              airwayBillNumber: [
                {
                  required: true,
                  type: "string",
                  message: "airwayBillNumber cannot be empty",
                  trigger: "blur"
                }
              ],
              type: [
                {
                  required: true,
                  type: "string",
                  message: "type cannot be empty",
                  trigger: "blur"
                }
              ]
            }
          },
          grid: [{ airwayBillNumber: 24 }, { type: 24 }],
          fields: [
            {
              key: "airwayBillNumber",
              name: () => this.$t("order_number"),
              component: "Input",
              bind: {
                type: "textarea",
                rows: 10
              },
              placeholder() {
                return this.$t("enter") + this.$t("order_number");
              }
            },
            {
              key: "type",
              name: () => this.$t("type"),
              component: "Select",
              config: {
                label({ row }) {
                  return this.$t(row.label);
                }
              },
              placeholder() {
                return this.$t("select") + this.$t("type");
              },
              options: typeList
            }
          ]
        },
        show: {
          config: {
            listFn: "list",
            modalBind: {
              width: "80%"
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            }
          },
          footer: {
            show: false
          },
          fields: [],
          table: {
            config: {
              align: "center",
              height: 600
            },
            fields: [
              {
                name: () => this.$t("order_number"),
                key: "airway_number",
                align: "center",
                copy: true,
                header: {
                  copy: true
                },
                tooltip: true,
                width: 150
              },
              {
                name: () => this.$t("order_refCode"),
                key: "agent_refer_code",
                align: "center",
                copy: true,
                header: {
                  copy: true
                },
                tooltip: true,
                width: 150
              },
              {
                name: () => this.$t("skuLength"),
                key: "length",
                align: "center",
                tooltip: true,
                minWidth: 120
              },
              {
                name: () => this.$t("skuWidth"),
                key: "width",
                align: "center",
                tooltip: true,
                minWidth: 100
              },
              {
                name: () => this.$t("skuHeight"),
                key: "height",
                align: "center",
                tooltip: true,
                minWidth: 100
              },
              {
                name: () => this.$t("charge_volume"),
                key: "charge_volume",
                align: "center",
                tooltip: true,
                minWidth: 100
              },
              {
                name: () => this.$t("claim_weight"),
                key: "claim_weight",
                align: "center",
                tooltip: true,
                minWidth: 100
              },
              {
                name: () => this.$t("check_weight"),
                key: "check_weight",
                align: "center",
                tooltip: true,
                minWidth: 100
              },
              {
                name: () => this.$t("bagTime"),
                key: "create_time",
                align: "center",
                tooltip: true,
                minWidth: 170
              }
            ]
          }
        }
      },
      header: {
        searchs: [
          {
            key: "startTime",
            component: "DatePicker",
            placeholder() {
              return (
                this.$t("select") +
                this.$t("start") +
                this.$t("date") +
                this.$t("time")
              );
            },
            bind: {
              type: "datetime",
              style: {
                width: "175px"
              }
            },
            methods: {
              "on-change"({ searchForm }) {
                searchForm.startTime = searchForm.startTime
                  ? this.$page.format.timeFormat(searchForm.startTime)
                  : "";
              }
            }
          },
          {
            key: "endTime",
            component: "DatePicker",
            placeholder() {
              return (
                this.$t("select") +
                this.$t("end") +
                this.$t("date") +
                this.$t("time")
              );
            },
            bind: {
              type: "datetime",
              style: {
                width: "175px"
              }
            },
            methods: {}
          },
          {
            key: "warehouse_id",
            placeholder() {
              return this.$t("select") + this.$t("warehouseName");
            },
            component: "Select",
            options: []
          },
          {
            key: "status",
            placeholder() {
              return this.$t("select") + this.$t("exlType");
            },
            component: "Select",
            config: {
              label({ row }) {
                return this.$t(row.label);
              }
            },
            options: statusList
          },
          {
            key: "is_board",
            placeholder() {
              return this.$t("select") + this.$t("is_board");
            },
            component: "Select",
            options: boardList
          },
          {
            key: "keywordsType",
            placeholder() {
              return this.$t("select") + this.$t("keywords_type");
            },
            component: "Select",
            config: {
              label({ row }) {
                return this.$t(row.label);
              }
            },
            options: [],
            methods: {
              async list({ field, searchForm }) {
                let res = await this.$sel.getData("OMS_BAG_KEYWORDS");
                field.options = res;
                searchForm[field.key] = res[0].value;
                this.$forceUpdate();
              }
            }
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            bind: {
              type: "textarea",
              rows: 1
            },
            component: "Input"
          }
        ],
        btns: {
          list: [
            {
              name: () => this.$t("export"),
              type: "export",
              btnBind: {
                type: "primary"
              },
              disabled() {
                return !this.selectAll.length;
              },
              list: [
                {
                  name: () => this.$t("LinkedData"),
                  type: "LinkedData",
                  fnName: "LinkedDataFun"
                },
                {
                  name: () => this.$t("ListData"),
                  type: "ListData",
                  fnName: "ListDataFun"
                }
              ]
            },
            {
              name: () => this.$tz("板货,操作"),
              type: "move",
              fnName: "move",
              bind: {
                type: "primary"
              }
            },
            {
              name: () => this.$tz("打印,袋子号"),
              type: "printLabel",
              fnName: "printLabel",
              bind: {
                type: "primary"
              }
            },
            {
              name: () => this.$tz("装袋,检测"),
              type: "Detection",
              fnName: "Detection",
              bind: {
                type: "primary"
              },
              id: 1844
            }
          ],
          methods: {
            Detection() {
              this.getModal("Detection").open(null, function() {
                this.setTitle(this.$tz("装袋,检测"));
              });
            },
            printLabel() {
              this.getModal("printLabel").open(null, function() {
                this.fields.forEach(t => {
                  if (t.key === "channel_id") t.options = [];
                });
                this.setTitle(this.$tz("打印,袋子号"));
              });
            },
            move() {
              this.getModal("move").open(null, function() {
                this.setTitle(this.$tz("板货,操作"));
              });
            },
            ListDataFun({ field, searchForm }) {
              this.exportExc(this.$t("bag") + "_" + this.$t("ListData"));
            },
            LinkedDataFun({ field, searchForm }) {
              let fields = [
                {
                  name: this.$tz("序号"),
                  key: "seq"
                },
                {
                  name: this.$t("order_number"),
                  key: "airway_bill"
                },
                {
                  name: this.$t("bagCode"),
                  key: "package_number"
                },
                {
                  name: this.$t("packing_number"),
                  key: "packing_number"
                }
              ];
              this.openLoading();
              this.handleRequestMethods(
                "exportPackage",
                {
                  package_id: this.selectAll.map(item => item.id)
                },
                false,
                true
              ).then(res => {
                this.exportExc({
                  data: res.payload.map((t, i) => {
                    t.seq = i + 1;
                    return t;
                  }),
                  fields,
                  name: this.$t("bag") + "_" + this.$t("LinkedData")
                });
              });
            }
          }
        }
      },
      fields: [
        {
          type: "checkbox",
          align: "center",
          width: 60,
          show: false
        },
        {
          name: () => this.$t("bagCode"),
          key: "package_number",
          align: "left",
          minWidth: 200
        },
        {
          name: () => this.$tz("板号"),
          key: "board_number",
          minWidth: 110
        },
        {
          name: this.$t("exlType"),
          key: "status",
          align: "center",
          minWidth: 100,
          render: (h, params) => {
            return h("div", [
              h(
                params.row.is_board == "YES" ? "Button" : "span",
                {
                  props: {
                    type: "dashed",
                    size: "small"
                  },
                  style: {
                    color:
                      params.row.is_board == "YES"
                        ? params.row.volume_size > 0
                          ? "#19be6b"
                          : "#ed4014"
                        : ""
                  }
                },
                params.row.is_board == "YES"
                  ? params.row.volume_size > 0
                    ? this.$t(statusList[1].label)
                    : this.$t(statusList[0].label)
                  : " / "
              )
            ]);
          }
        },
        {
          name: () => this.$t("warehouseCode"),
          key: "warehouseTitle",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("status_operator"),
          key: "operator_name",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("invoicePCS"),
          key: "order_count",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("invoiceWeight"),
          key: "order_weight",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("skuLength"),
          key: "length",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("skuWidth"),
          key: "width",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("skuHeight"),
          key: "height",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("skuVolume"),
          key: "volume_size",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("is_board"),
          key: "is_board",
          align: "center",
          width: 80,
          methods: {
            render({ value }) {
              return boardList.find(item => item.value == value).label;
            }
          }
        },
        {
          name: () => this.$t("createTime"),
          key: "create_time",
          align: "center",
          minWidth: 180
        },
        {
          type: "btns",
          width: 250,
          name: () => this.$t("operation"),
          fixed: "right",
          list: [
            {
              name: () => this.$t("show"),
              type: "show",
              fnName: "showFun",
              bind: {
                type: "primary"
              },
              id: 338,
              disabled({ row }) {
                return row.order_count < 1;
              }
            },
            {
              name: () => this.$t("operation"),
              type: "operation",
              fnName: "operationFun",
              bind: {
                type: "warning"
              },
              id: 186
            },
            {
              name: () => this.$t("startStatist"),
              type: "statistics",
              fnName: "statisticsFun",
              bind: {
                type: "success"
              },
              show: ({ row }) => {
                return row.is_board == "YES";
              }
            }
          ],

          methods: {
            async showFun({ row }) {
              let res = await this.handleRequestMethods("getDetails", {
                BaggingNo: row.package_number
              });
              this.getModal("show").open(
                { data: res.payload.airwayBillNumber },
                function() {
                  console.log(this);
                  this.list = res.payload.airwayBillNumber;
                  this.setTitle(this.$t("show"));
                }
              );
            },
            async operationFun({ row }) {
              this.getModal("operation").open(
                {
                  packageId: row.package_number
                },
                function() {
                  this.setTitle(this.$t("operation"));
                }
              );
            },
            statisticsFun({ row }) {
              this.$Modal.confirm({
                title:
                  this.$t("whether") +
                  this.$t("confirm") +
                  this.$t("startStatist") +
                  row.package_number +
                  "?",
                onOk: () => {
                  this.handleRequestMethods(
                    "postStatist",
                    {
                      packageId: row.package_number
                    },
                    true
                  ).then(res => {
                    // this.$Message.success(res.data.msg);
                    this.getList();
                  });
                }
              });
            }
          }
        }
      ]
    };
  }
};
</script>
<style type="text/css">
/* @page{
    size: 7cm 8cm;
  } */
</style>
<style lang="scss" scoped></style>
